export default "__VITE_ASSET__BdFwCA9Y__"